import util from '@/libs/util'

const post = util.ajax.post

export const cardetailUrls = [
  // 查询
  '/recordCarDetail/list'
]

export const cardetail = {}

cardetail.listCarDetail = function (params) {
  return post('/recordCarDetail/list', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/record/cardetail.js